<app-header></app-header>
<div id="content">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
